/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { CloudConnectServerWithDeployInfo, ResellerCloudConnectAgent } from '@veeam-vspc/models/web-controllers';

export const getResellerCcAgent = (resellerCcAgents: ResellerCloudConnectAgent[], agent: CloudConnectServerWithDeployInfo) =>
    resellerCcAgents.find(item => item.cloudConnectAgentUid === agent.agentGuid);
